/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export enum FileActions {
  FETCH_HIGHLIGHTS = '[File] Fetch Highlights',
  SET_LOADING = '[File] Set Loading',
  SET_ERROR = '[File] Set Error',
}
